
// FILL EMPTY VALUES OF PLACEHOLDERS
//
// INFO: For the "Floating Label" mechanism, the presence of a "placeholder" attribute is obligatory. But without a value, it counts as _not_ set.


document.addEventListener('DOMContentLoaded', () => {
    // Function to check form elements and fill undefined placeholders
    function checkAndSetPlaceholders() {
        const formElements = document.querySelectorAll('input, textarea');

        formElements.forEach(element => {
            // Check if element has an empty 'placeholder' attribute
            if (element.hasAttribute('placeholder')) {
                const placeholder = element.getAttribute('placeholder');
                if (placeholder === null || placeholder === '') {
                    element.setAttribute('placeholder', ' ');
                }
            }
        });
    }

    // Observe the DOM for changes
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            // Check when child elements are added or attributes changed
            if (mutation.type === 'childList' || mutation.type === 'attributes') {
                checkAndSetPlaceholders();
            }
        });
    });

    // Configure the observer
    const config = { childList: true, subtree: true, attributes: true, attributeFilter: ['placeholder'] };

    // Start the Observer for the whole document
    observer.observe(document.body, config);

    // Initial check
    checkAndSetPlaceholders();
});
